<div class="container-important" [ngClass]="{'tw-hidden': loaded}">
  <app-skeleton-template *ngIf="!loaded" [template]="skeletonTemplate"></app-skeleton-template>
</div>

<div class="container-important" *ngIf="patientRelevantDataMiniSphere">
  <!-- nombre, edad y genero del paciente -->
  <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
    <div class="grid-item max-auto tw-relative tw-w-full">
      <div *ngIf="patient" class="tw-flex tw-items-center tw-mt-14 md:tw-mt-0 tw-mb-5 tw-w-4/5 sm:tw-w-full">
        <app-avatar-user [image]="patient.user?.profileImageURL" [name]="patient.user?.name"
                         [lastname]="patient.user?.lastname" [width]="50"></app-avatar-user>
        <div class="tw-ml-4">
          <p class="tw-text-gray-700 tw-text-lg md:tw-text-xl">
            {{ patient.user?.name }} {{ patient.user?.lastname }}
            <img loading="lazy" class="tw-ml-2 tw-w-5"
                 [src]="patient.user.gender === genderEnum.FEMALE ? './../../../assets/images/icons/icons8-female-100.png' : './../../../assets/images/icons/icons8-male-100.png'"
                 alt=""
            />
          </p>
          <p class="text-info">{{ patient.user.birthday | date: 'mediumDate' }}, {{ patient.user.birthday | getAge }}
            años</p>
        </div>
      </div>
      <div class="tw-mb-5">
        <p class="text-subtitle-bold-upper">
          Nivel de salud del paciente
        </p>
        <p class="text-info">Mediante inferencias realizadas por el sistema se determina el nivel de salud actual del
          paciente.</p>
      </div>
      <!--tw-flex tw-items-start tw-flex-wrap tw-gap-2-->
      <div class="tw-flex tw-flex-col lg:tw-flex-row">
        <!--tw-flex tw-items-start-->
        <div class="">
          <div class="tw-mr-3">
            <p class="tw-text-blue-400 tw-text-xs">{{ this.patientRelevantDataMiniSphere.score.toFixed(2) }} puntos</p>
            <p class="tw-text-xl"
               [ngClass]="{'tw-text-yellow-500': this.patientRelevantDataMiniSphere.totalPercentage < 31, 'tw-text-orange-500': this.patientRelevantDataMiniSphere.totalPercentage > 30 && this.patientRelevantDataMiniSphere.totalPercentage < 61, 'tw-text-red-500': this.patientRelevantDataMiniSphere.totalPercentage > 60}">{{ this.patientRelevantDataMiniSphere.totalPercentage.toFixed(2) }}
              %</p>
          </div>
          <app-progress-body [percentage]="this.patientRelevantDataMiniSphere.totalPercentage"></app-progress-body>
        </div>
        <!--tw-flex tw-flex-wrap tw-gap-2 grid-container--> <!--grid grid-flow-row auto-rows-max-->
        <div class="tw-flex tw-flex-wrap md:tw-grid tw-grid-rows-none md:tw-grid-rows-3 lg:tw-grid-rows-2 2xl:tw-grid-rows-1 tw-grid-flow-col tw-gap-4">
          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-cerveza-100.png" alt="">
              Alcohol
            </div>

            <div class="tw-flex tw-flex-col">
              <span class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.alcohol.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.alcohol.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-exercise-100.png" alt="">
              Actividad física
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.physicalActivity.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.physicalActivity.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-cigar-100.png"
                   alt="">
              Fuma
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.smoke.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.smoke.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-positive-thinking-64.png"
                   alt="">
              Actitud
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.attitude.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.attitude.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>

          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-durmiendo-en-la-cama-100.png"
                   alt="">
              Sueño
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.sleep.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.sleep.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-persuasion-64.png"
                   alt="">
              Entorno de afectividad
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.environmentAffectivity.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.environmentAffectivity.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-disease-100.png" alt="">
              Carga genética familiar
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.medicalInheritedFamily.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.medicalInheritedFamily.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-activities-64.png"
                   alt="">
              Actividades enriquecedoras
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.enrichingActivities.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.enrichingActivities.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>
          <div class="tw-w-full tw-m-0 tw-text-gray-700 tw-font-semibold tw-mr-9 tw-flex tw-flex-col">
            <div class="tw-flex tw-items-center">
              <img class="tw-w-5 tw-mr-2" src="./../../../assets/images/icons/icons8-estres-64.png"
                   alt="">
              Estrés
            </div>
            <div class="tw-flex tw-flex-col">
              <span
                class="tw-text-blue-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.stress.score.toFixed(2) }}
                puntos</span>
              <span
                class="tw-text-red-400 tw-text-xs tw-ml-5">{{ this.patientRelevantDataMiniSphere.stress.totalPercentage.toFixed(2) }}
                %</span>
            </div>
          </div>

        </div>
      </div>

      <!---->
      <button nz-button nzType="primary" class="button-change-view" (click)="this.onSwitchSphere()" *ngIf="(this.isExpert$ | async)">
        {{ (recordMode$ | async) === sepherMode.COMPLETE ? 'Visualizar Mini Esfera' : 'Visualizar Esfera' }}
      </button>
      <i class="text-info cursor-pointer close-information" nz-icon nzType="close" nzTheme="outline" (click)="this.onCloseSphere($event)"></i>
    </div>
  </div>

  <div class="grid-container tw-mt-6 tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-4">
    <!-- Actividad física -->
    <div class="grid-item tw-flex tw-justify-between tw-flex-col">
      <!--<div class="grid-item-layer" *ngIf="!patientRelevantDataMiniSphere.physicalActivity.saved && userLogged.experts">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado datos en la ficha de actividad física. Puede registrarlos dando clic <span
          class="text-link"
          (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.MINI_SPHERE)">aquí</span>
        </p>
      </div>
      <div class="grid-item-layer" *ngIf="!patientRelevantDataMiniSphere.physicalActivity.saved && userLogged.patients">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado datos en la ficha de actividad física
        </p>
      </div>-->
      <div>
        <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-justify-between tw-items-center">
          <div>
            <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-exercise-100.png" alt="">
            Actividad física
          </div>
        </div>
        <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
          <div>
            <ng-container
              *ngIf="physicalActivityLevelEnum.NO_ACTIVITY !== patientRelevantDataMiniSphere.physicalActivity?.physicalLevelActivity">
              <p class="tw-font-semibold tw-text-gray-700">
                Hace {{ patientRelevantDataMiniSphere.physicalActivity.physicalLevelActivity | getTranslateEnum:'physicalActivityLevel' }}</p>
              <p class="text-info tw-whitespace-normal tw-mb-5"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>{{ levelActivity[patientRelevantDataMiniSphere.physicalActivity?.physicalLevelActivity]?.description }}
              </p>

              <p class="tw-text-gray-400 tw-text-sm">Horas de ejercicio a la semana</p>
              <p
                class="text-info tw-mb-5">{{ patientRelevantDataMiniSphere.physicalActivity?.exercisePerWeek }} {{ patientRelevantDataMiniSphere.physicalActivity?.exercisePerWeek === 1 ? ' hora.' : ' horas' }}</p>

              <p class="tw-text-gray-400 tw-text-sm">Ocupación</p>
              <p class="text-info tw-mb-5">{{ patientRelevantDataMiniSphere.physicalActivity?.occupation }}</p>
            </ng-container>
            <p class="tw-text-gray-400 tw-text-sm">
              Nivel de sedentarismo
              <i class="tw-ml-1" nz-icon nzType="info-circle" nzTheme="outline" nz-popover="" [nzPopoverContent]="sedentaryTableTemplate"
                 nzTooltipTitle="Niveles de sedentarismo"></i>
            </p>
            <ng-container>
              <ng-template #sedentaryTableTemplate>
                <div>
                  <p class="text-info tw-mb-2 tw-w-80">
                    Ver películas, redes sociales o videojuegos en celular, tableta, computadora,
                    hablar por teléfono sentado, estar tumbado en el sofá, otros juegos sedentarios.
                  </p>
                  <ul class="ingredient-list ml-xs">
                    <li class="tw-text-gray-400">Leve: 0 a 2 horas</li>
                    <li class="tw-text-gray-400">Moderado: 2 a 4 horas</li>
                    <li class="tw-text-gray-400">Alto: más de 4 horas</li>
                  </ul>
                </div>
                <div>
                  <p class="text-info tw-mb-2 tw-w-80">
                    Escuela, oficina, investigación, lectura, estudio, viaje en coche, vuelos, etc.
                  </p>
                  <ul class="ingredient-list ml-xs">
                    <li class="tw-text-gray-400">Leve: 0 a 2 horas</li>
                    <li class="tw-text-gray-400">Moderado: 2 a 4 horas</li>
                    <li class="tw-text-gray-400">Alto: más de 4 horas</li>
                  </ul>
                </div>
              </ng-template>
              <p class="text-info tw-mb-5" *ngIf="patientRelevantDataMiniSphere.physicalActivity?.sedentary">En promedio: <span
                class="{{sedentaryLevel[patientRelevantDataMiniSphere.physicalActivity?.sedentary?.name]}}">{{ patientRelevantDataMiniSphere.physicalActivity?.sedentary.name | getTranslateEnum:'sedentaryLevel' }}
                , {{ patientRelevantDataMiniSphere.physicalActivity?.sedentary.value + (patientRelevantDataMiniSphere.physicalActivity?.sedentary.value === 1 ? ' hora' : ' horas')}} </span>
              </p>
              <p *ngIf="!patientRelevantDataMiniSphere.physicalActivity?.sedentary" class="text-info">No hay datos de sedentarismo registrados</p>
            </ng-container>
            <!--<p class="text-info" *ngIf="!patientRelevantDataMiniSphere.physicalActivity?.sedentary">No se han establecido parámetros
              en la ficha de actividad física.</p>-->
            <p class="tw-text-gray-400 tw-text-sm tw-mt-5 tw-mb-3">Intensidad del ejercicio</p>
            <app-thermometer *ngIf="patientRelevantDataMiniSphere.physicalActivity?.exerciseIntensity >= 0"
                             [percentage]="(patientRelevantDataMiniSphere.physicalActivity?.exerciseIntensity || 0) * 10"></app-thermometer>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.physicalActivity?.exerciseIntensity === undefined">No se ha
              determinada la intensidad del ejercicio en la ficha de actividad física.</p>
          </div>
        </div>
      </div>
      <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
        <div>
          <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
            <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
            {{this.patientRelevantDataMiniSphere.physicalActivity.score}} puntos
          </p>
        </div>
        <div class="tw-flex tw-items-center">
          <p
            class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.physicalActivity.percentage.toFixed(2) }}
            %</p>
          <app-progress-heart
            [percentage]="this.patientRelevantDataMiniSphere.physicalActivity.percentage"></app-progress-heart>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <!-- Alcohol -->
      <div class="grid-item tw-flex tw-justify-between tw-flex-col">
        <div>
          <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
            <div>
              <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-cerveza-100.png" alt="">
              Alcohol
            </div>
            <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
                  nzTooltipTitle="">
          </span>
          </div>
          <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
            <p class="tw-text-gray-400 tw-text-sm">¿El bebe alcohol?</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.alcohol?.drinkAlcohol">
              Sí, {{(patientRelevantDataMiniSphere.alcohol?.drinkAlcoholFrequency + '') | getTranslateEnum: 'habitsFrequency'}}</p>
            <p class="text-info" *ngIf="!patientRelevantDataMiniSphere.alcohol?.drinkAlcohol">No</p>
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantDataMiniSphere.alcohol.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.alcohol.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantDataMiniSphere.alcohol.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
      <!-- Fuma -->
      <div class="grid-item tw-flex tw-justify-between tw-flex-col">
        <div>
          <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
            <div>
              <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-cigar-100.png" alt="">
              Fuma
            </div>
            <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
                  nzTooltipTitle="">
                    <!--{{(patientRelevantDataMiniSphere.alcohol.updatedAt || currentDate) | date: 'MMM d, y'}}-->
            </span>
          </div>
          <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
            <p class="tw-text-gray-400 tw-text-sm">¿El paciente fuma?</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.smoke?.smoke">
              Sí, {{(patientRelevantDataMiniSphere.smoke?.smokeFrequency + '') | getTranslateEnum: 'habitsFrequency'}}</p>
            <p class="text-info" *ngIf="!patientRelevantDataMiniSphere.smoke?.smokeFrequency">No</p>
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantDataMiniSphere.smoke.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.smoke.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantDataMiniSphere.smoke.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <!-- Actividades enriquecedoras -->
      <div class="grid-item tw-flex tw-justify-between tw-flex-col">
        <div>
          <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
            <div class="tw-flex">
              <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-activities-64.png" alt="">
              Actividades enriquecedoras
            </div>
            <span class="tw-text-xs tw-text-gray-400 tw-lowercase" nz-popover="" [nzPopoverContent]="'última actualización'"
                  nzTooltipTitle="">
                  <!--{{(patientRelevantDataMiniSphere.alcohol.updatedAt || currentDate) | date: 'MMM d, y'}}-->
          </span>
          </div>
          <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
            <p class="tw-text-gray-400 tw-text-sm">¿El paciente realiza alguna actividad?</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.enrichingActivities?.hasActivity">
              Sí. {{patientRelevantDataMiniSphere.enrichingActivities?.activity + ' ' + patientRelevantDataMiniSphere.enrichingActivities.frequency + ' días a la semana' }}</p>
            <p class="text-info" *ngIf="!patientRelevantDataMiniSphere.enrichingActivities?.hasActivity">No</p>
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantDataMiniSphere.enrichingActivities.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.enrichingActivities.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantDataMiniSphere.enrichingActivities.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
      <!-- Actitudes -->
      <div class="grid-item tw-flex tw-justify-between tw-flex-col">
        <div>
          <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
            <div>
              <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-positive-thinking-64.png" alt="">
              Actitud del paciente
            </div>
          </div>
          <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
            <p class="tw-text-gray-400 tw-text-sm">¿El paciente considera que cuenta con el potencial para alcanzar sus metas?</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.attitude.potentialToReachMyGoals">
              {{(patientRelevantDataMiniSphere.attitude?.potentialToReachMyGoals) | getStatementStatus}}</p>
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantDataMiniSphere.attitude.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.attitude.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantDataMiniSphere.attitude.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <!-- Sueño -->
      <div class="grid-item tw-flex tw-justify-between tw-flex-col">
        <div>
          <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
            <div>
              <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-durmiendo-en-la-cama-100.png" alt="">
              Sueño
            </div>
          </div>
          <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
            <p class="tw-text-gray-400 tw-text-sm">Promedio de horas que el paciente duerme por noche</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.sleep">
              {{this.patientRelevantDataMiniSphere.sleep.howManyHoursDoYouSleepOnAveragePerNight}}
            <p class="tw-text-gray-400 tw-text-sm tw-mt-5">Horario promedio de sueño del paciente</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGoToSleep && patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGetUp">
              {{this.patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGoToSleep | date: 'h:mm aa'}} - {{this.patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGetUp | date: 'h:mm aa'}}
            </p>
            <div class="text-info" *ngIf="!patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGoToSleep || !patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGetUp">
              <p class="text-info tw-mt-1">No se han definido los 2 horarios.</p>
              <p>Horario en que duerme: {{!this.patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGoToSleep ? 'No definido' : (this.patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGoToSleep | date: 'h:mm aa')}}</p>
              <p>Horario en que despierta: {{!this.patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGetUp ? 'No definido' : (this.patientRelevantDataMiniSphere.sleep.whatTimeDoYouUsuallyGetUp | date: 'h:mm aa')}}</p>
            </div>
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantDataMiniSphere.sleep.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.sleep.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantDataMiniSphere.sleep.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
      <!-- Entorno de afectividad -->
      <div class="grid-item tw-flex tw-justify-between tw-flex-col">
        <div>
          <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
            <div>
              <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-persuasion-64.png" alt="">
              Entorno de afectividad
            </div>
          </div>
          <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
            <p class="tw-text-gray-400 tw-text-sm">El paciente se siente feliz a menudo</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.environmentAffectivity">
              {{(patientRelevantDataMiniSphere.environmentAffectivity?.feelHappyOften) | getStatementStatus}}
            <p class="tw-text-gray-400 tw-text-sm tw-mt-5">El paciente cuenta con amigos y/o familiares en tiempos de crisis</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.environmentAffectivity">
              {{(patientRelevantDataMiniSphere.environmentAffectivity?.trustWithFamilyAndFriends) | getStatementStatus}}
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantDataMiniSphere.sleep.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.environmentAffectivity.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantDataMiniSphere.environmentAffectivity.percentage"></app-progress-heart>
          </div>
        </div>
      </div>
    </div>
    <!-- carga genetica familiar -->
    <div class="grid-item tw-flex tw-justify-between tw-flex-col">
      <div class="grid-item-layer" *ngIf="patientRelevantDataMiniSphere.medicalInheritedFamily.recordMedicalInheritedFamily === null && userLogged.experts">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado enfermedades heredo-familiares. Puede registrarlas dando clic <span
          class="text-link" (click)="$event.stopPropagation();onRedirectTo(recordTypeEnum.MINI_SPHERE)">aquí</span>
        </p>
      </div>
      <div class="grid-item-layer" *ngIf="!patientRelevantDataMiniSphere.medicalInheritedFamily.recordMedicalInheritedFamily === null && userLogged.patients">
        <p class="tw-text-gray-700 tw-font-bold tw-text-center">
          Detectamos que no se han registrado enfermedades heredo-familiares
        </p>
      </div>
      <div>
        <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
          <div>
            <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-disease-100.png" alt="">
            Carga genética
          </div>
        </div>
        <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
          <div>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.medicalInheritedFamily?.recordMedicalInheritedFamily === null">No se
              han registrado enfermedades.</p>
            <div *ngIf="patientRelevantDataMiniSphere.medicalInheritedFamily?.recordMedicalInheritedFamily !== null &&
              patientRelevantDataMiniSphere.medicalInheritedFamily?.recordMedicalInheritedFamily.diseaseCategories.length > 0">
              <div *ngFor="let category of patientRelevantDataMiniSphere.medicalInheritedFamily.recordMedicalInheritedFamily.diseaseCategories">
                <p class="tw-text-gray-400 tw-text-sm">{{ category.name }}</p>
                <div *ngFor="let disease of category.diseases">
                  <div class="tw-flex tw-items-center tw-ml-2">
                    <p
                      class="tw-text-gray-800 tw-font-semibold tw-text-xs tw-uppercase tw-mr-2">{{ disease.identifier }}</p>
                    <p class="tw-text-gray-500 tw-text-xs">{{ disease.name }}</p>
                  </div>
                  <span class="tw-text-gray-800 tw-text-xs tw-ml-2"
                        *ngIf="disease.familyMembers | getCountDiseaseParents; let parentCount">Presentada por {{ parentCount }} {{ parentCount === 1 ? 'pariente.' : 'parientes.' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
        <div>
          <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
            <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
            {{ this.patientRelevantDataMiniSphere.medicalInheritedFamily.score}} puntos
          </p>
        </div>
        <div class="tw-flex tw-items-center">
          <p
            class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.medicalInheritedFamily.percentage.toFixed(2) }}
            %</p>
          <app-progress-heart
            [percentage]="this.patientRelevantDataMiniSphere.medicalInheritedFamily.percentage"></app-progress-heart>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <!-- Estrés -->
      <div class="grid-item tw-flex tw-justify-between tw-flex-col">
        <div>
          <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
            <div>
              <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-estres-64.png" alt="">
              Estrés
            </div>
          </div>
          <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
            <p class="tw-text-gray-400 tw-text-sm">¿El paciente con que frecuencia a sentido que las dificultades se acumulan tanto que no puede superarlas?</p>
            <p class="text-info" *ngIf="patientRelevantDataMiniSphere.stress">
              <!--{{(patientRelevantDataMiniSphere.stress?.howOftenHaveFeltThatDifficultiesArePilingUpSoMuchThatCanOvercomeThem) | getStatementStatus}}</p>-->
              {{options[patientRelevantDataMiniSphere.stress?.howOftenHaveFeltThatDifficultiesArePilingUpSoMuchThatCanOvercomeThem]}}
          </div>
        </div>
        <div class=" tw-mt-3 tw-flex tw-items-center tw-justify-between">
          <div>
            <p class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
              <span class="tw-mr-3" nz-icon nzType="solution" nzTheme="outline"></span>
              {{this.patientRelevantDataMiniSphere.stress.score}} puntos
            </p>
          </div>
          <div class="tw-flex tw-items-center">
            <p
              class="tw-text-red-500 tw-text-sm tw-mr-3">{{ this.patientRelevantDataMiniSphere.stress.percentage.toFixed(2) }}
              %</p>
            <app-progress-heart [percentage]="this.patientRelevantDataMiniSphere.stress.percentage"></app-progress-heart>
          </div>
        </div>
      </div>

      <!-- alimentación -->
      <div class="grid-item">
        <div class="text-subtitle-bold-upper tw-mb-5 tw-flex tw-items-center tw-justify-between">
          <div>
            <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-biting-a-carrot-100.png" alt="">
            Alimentación
          </div>
        </div>

        <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
          <div>
            <p class="tw-text-gray-400 tw-text-sm">Plan alimenticio</p>
            <ng-container *ngIf="patientRelevantDataMiniSphere.feeding?.mealPlan">
              <div class="text-info tw-flex tw-justify-between">
                {{ patientRelevantDataMiniSphere.feeding?.mealPlan?.name }}

                <div class="tw-flex tw-items-center">
                  <img class="tw-w-5" loading="lazy" src="./../../../assets/images/icons/icons8-chocolatina-100.png"
                       alt="">
                  <p
                    class="tw-text-gray-500 tw-text-xs">{{ patientRelevantDataMiniSphere.feeding?.mealPlan?.macronutrients?.netWeight || 0 }}
                    kcal</p>
                </div>
              </div>

              <div class="macros tw-mt-5">
                <div class="macro">
                  <div class="macro-value">
                    <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-sunny-side-up-huevos-100.png" alt=""> -->
                    <p
                      class="tw-text-gray-800 tw-text-xs">{{ patientRelevantDataMiniSphere.feeding?.mealPlan?.macronutrients?.totalFat_g || 0 }}
                      g</p>
                  </div>
                  <p class="tw-text-gray-500 tw-text-xs">Grasas</p>
                </div>
                <div class="macro">
                  <div class="macro-value">
                    <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-pastel-de-nata-100.png" alt=""> -->
                    <p
                      class="tw-text-gray-800 tw-text-xs">{{ patientRelevantDataMiniSphere.feeding?.mealPlan?.macronutrients?.carbohydrate_g || 0 }}
                      g</p>
                  </div>
                  <p class="tw-text-gray-500 tw-text-xs">H.C.</p>
                </div>
                <div class="macro">
                  <div class="macro-value">
                    <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-jamon-100.png" alt=""> -->
                    <p
                      class="tw-text-gray-800 tw-text-xs"> {{ patientRelevantDataMiniSphere.feeding?.mealPlan?.macronutrients?.protein_g || 0 }}
                      g</p>
                  </div>
                  <p class="tw-text-gray-500 tw-text-xs">Proteínas</p>
                </div>
                <div class="macro">
                  <div class="macro-value">
                    <!-- <img loading="lazy" src="./../../../assets/images/icons/icons8-heno-100.png" alt=""> -->
                    <p
                      class="tw-text-gray-800 tw-text-xs">{{ patientRelevantDataMiniSphere.feeding?.mealPlan?.macronutrients?.dietaryFiber_g || 0 }}
                      g</p>
                  </div>
                  <p class="tw-text-gray-500 tw-text-xs">Fibra</p>
                </div>
              </div>
            </ng-container>
            <p class="text-info" *ngIf="!patientRelevantDataMiniSphere.feeding?.mealPlan">No se tiene asignado un plan
              alimenticio.</p>

          </div>

        </div>
      </div>
    </div>
    <!-- resultados de laboratorios -->
    <div class="grid-item min-h-scroll">
      <p class="tw-flex text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-biochemist-64.png" alt="">
        Resultado de laboratorios
      </p>
      <ng-scrollbar class="my-scrollbar  scroll-section min-h-scroll biochemical-scrollbar">  <!--biochemical-scrollbar-->
        <div class="tw-flex tw-flex-col" *ngIf="this.biochemical.length > 0">
          <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100"
               *ngFor="let biochemical of this.biochemical"
          >
            <p class="tw-text-gray-400 tw-text-sm tw-mb-1 tw-flex tw-items-center tw-justify-between">
              {{ biochemical.nameEs }}
            </p>
            <p class="text-info">{{biochemical.value}} {{ biochemical.measureUnitSymbolEs }}</p>
          </div>
        </div>
        <p class="text-info" *ngIf="this.biochemical.length === 0">No se han registrado
          resultados de laboratorios.</p>
      </ng-scrollbar>
      <div class="scroll-section tw-block sm:tw-hidden">
        <div class="tw-flex tw-flex-col" *ngIf="this.biochemical.length > 0">
          <div class="tw-p-2 tw-rounded-md tw-mb-2 tw-border tw-border-solid tw-border-gray-100"
               *ngFor="let biochemical of this.biochemical"
          >
            <p class="tw-text-gray-400 tw-text-sm tw-mb-1 tw-flex tw-items-center tw-justify-between">
              {{ biochemical.nameEs }}
            </p>
            <p class="text-info">{{biochemical.value}} {{ biochemical.measureUnitSymbolEs }}</p>
          </div>
        </div>
        <p class="text-info" *ngIf="this.biochemical.length === 0">No se han registrado
          resultados de laboratorios.</p>
      </div>
    </div>
    <!-- preferencias -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-handshake-100.png" alt="">
        Preferencias
      </p>

      <p class="tw-text-gray-400 tw-text-sm">Régimen alimenticio</p>
      <p class="text-info">{{ patientRelevantDataMiniSphere.nutritionalHistory?.feedingPreference || 'no establecido' }}</p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">Alergia a medicamento</p>
      <p class="text-info">{{ patientRelevantDataMiniSphere.nutritionalHistory?.allergicToAnyMedication || 'no establecido' }}</p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">Alergias</p>
      <p class="text-info">
        {{ patientRelevantDataMiniSphere.nutritionalHistory?.allergies.length > 0 ?
        (patientRelevantDataMiniSphere.nutritionalHistory?.allergies | stringifyArray:'ingredientName') :
        'no establecido'
        }}
      </p>

      <p class="tw-text-gray-400 tw-text-sm tw-mt-5">No le gustan los alimentos</p>
      <p class="text-info">
        {{ patientRelevantDataMiniSphere.nutritionalHistory?.foodDislikes &&
          patientRelevantDataMiniSphere.nutritionalHistory?.foodDislikes.length > 0 ?
          (patientRelevantDataMiniSphere.nutritionalHistory?.foodDislikes | stringifyArray: 'ingredientName') :
          'No establecido' }}</p>
    </div>
    <!-- diagnostico medico -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-medical-report-100.png" alt="">
        Diagnóstico médico
      </p>
      <div class="tw-flex tw-flex-col tw-justify-between max-h-section">
        <div>
          <p class="text-info" *ngIf="patientRelevantDataMiniSphere.medicalPersonal?.recordMedicalPersonal === null">No se
            han registrado enfermedades.</p>
          <div *ngIf="patientRelevantDataMiniSphere.medicalPersonal?.recordMedicalPersonal !== null &&
              patientRelevantDataMiniSphere.medicalPersonal?.recordMedicalPersonal.diseaseCategories.length > 0">
            <div *ngFor="let category of patientRelevantDataMiniSphere.medicalPersonal.recordMedicalPersonal.diseaseCategories">
              <p class="tw-text-gray-400 tw-text-sm">{{ category.name }}</p>
              <div *ngFor="let disease of category.diseases">
                <div class="tw-flex tw-items-center tw-ml-2">
                  <p
                    class="tw-text-gray-800 tw-font-semibold tw-text-xs tw-uppercase tw-mr-2">{{ disease.identifier }}</p>
                  <p class="tw-text-gray-500 tw-text-xs">{{ disease.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<p class="text-info" *ngIf="patientRelevantDataMiniSphere.medicalPersonal?.recordMedicalPersonal.diseaseCategories.length === 0">No se han
        registrado enfermedades.</p>
      {{patientRelevantDataMiniSphere.medicalPersonal?.recordMedicalPersonal.diseaseCategories.length}}
      <ng-scrollbar class="my-scrollbar scroll-section"
                    *ngIf="patientRelevantDataMiniSphere.medicalPersonal?.recordMedicalPersonal.diseaseCategories.length > 0">
        <div *ngIf="patientRelevantDataMiniSphere.medicalPersonal?.recordMedicalPersonal.diseaseCategories.length > 0">
          <div *ngFor="let category of patientRelevantDataMiniSphere.medicalPersonal.recordMedicalPersonal.diseaseCategories">
            <p class="tw-text-gray-400 tw-text-sm tw-mt-3">{{ category.name }}</p>
            <div *ngFor="let disease of category.diseases">
              <div class="tw-flex tw-items-center tw-ml-2">
                <p
                  class="tw-text-gray-800 tw-font-semibold tw-text-xs tw-uppercase tw-mr-2">{{ disease.identifier }}</p>
                <p class="tw-text-gray-500 tw-text-xs">{{ disease.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>-->
    </div>
    <!-- Examen físico nutricional -->
    <div class="grid-item">
      <p class="text-subtitle-bold-upper tw-mb-5">
        <img class="tw-w-8 tw-mr-2" src="./../../../assets/images/icons/icons8-examination-64.png" alt="">
        Examen físico nutricional
      </p>

      <p class="text-info">{{
        patientRelevantDataMiniSphere.nutritionalPhysicalExamination?.observations !== '' ?
        patientRelevantDataMiniSphere.nutritionalPhysicalExamination?.observations :
        'No hay información.'
        }}</p>

    </div>

  </div>
</div>
